// src/components/option/utility.ts
var delimiterToWhiteSpace = (value, delimiter) => {
  const escapedDelimiter = delimiter.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedDelimiter, "g");
  return value.replace(regex, "_");
};
export { delimiterToWhiteSpace };
